export const privatePolicyText = `
<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
</head>
<body>
<div class="terms">
  <style>
    .terms p { font-size: 17px; }
    .terms li { font-size: 15px; }
    .terms h2 { font-size: 19px; }             /* 필요시 !important 추가 */
    .terms h3 { font-size: 19px; } 
    .terms h3 + ul { margin-top: -10px; }
    .terms p + ul { margin-top: -10px; }
    .terms h2 + p { margin-top: -10px; }
    .terms p + h2 { margin-top: 24px; }

    @media (max-width: 1439px) {
    .terms p  { font-size: 14px; }
    .terms li { font-size: 14px; }  
    .terms h1 { font-size: 24px; }      
    .terms h2 { font-size: 14px; }
    .terms h3 { font-size: 14px; }
  }
  </style>

  <h1>개인정보 처리방침</h1>

  <p><b>
    비비테크(이하 ‘회사’)는 이용자가 개인정보를 소중하게 생각하며, 『개인정보 보호법』 등 관련 법령을 준수하여 개인정보를 안전하게 보호하고, 적법하게 처리하기 위해 다음과 같은 개인정보 처리방침을 수립·공개합니다.
  </b></p>

  <h2>1. 개인정보의 수집 항목 및 수집 방법</h2>
  <p>회사는 다음과 같은 항목의 개인정보를 수집할 수 있습니다.</p>

  <h3>1-1. 수집 항목</h3>
  <ul>
    <li>필수 항목: 이름, 연락처(전화번호, 이메일), 소속(회사명 또는 직책)</li>
    <li>선택 항목: 문의 내용, 파일 첨부 등</li>
  </ul>

  <h3>1-2. 수집 방법</h3>
  <ul>
    <li>홈페이지 문의폼 기입 양식</li>
    <li>이메일 또는 전화 상담</li>
    <li>오프라인 문서 및 행사 응모 등</li>
  </ul>

  <h2>2. 개인정보의 수집 및 이용 목적</h2>
  <p>회사는 수집한 개인정보를 다음 목적을 위해 활용합니다.</p>
  <ul>
    <li>고객 문의 및 상담 응대</li>
    <li>서비스 제공 및 개선</li>
    <li>법령 또는 이용자의 동의에 따라 필요한 고지·안내</li>
    <li>마케팅 활용 시 별도 동의 받은 경우에 한함</li>
  </ul>

  <h2>3. 개인정보의 보유 및 이용 기간</h2>
  <p>
    회사는 원칙적으로 개인정보의 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관련 법령에 따라 보관이 필요한 경우에는 해당 기간 동안 안전하게 보관됩니다.
  </p>
  <ul>
    <li>고객 문의 기록: 3년</li>
    <li>계약 또는 요금 결제 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
  </ul>

  <h2>4. 개인정보의 제3자 제공</h2>
  <p>
    회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
  </p>
  <ul>
    <li>이용자가 사전에 동의한 경우</li>
    <li>법령에 의해 제공이 요구되는 경우</li>
  </ul>

  <h2>5. 개인정보의 처리 위탁</h2>
  <p>
    회사는 원활한 서비스를 제공을 위해 일부 업무를 외부 전문 업체에 위탁할 수 있으며, 위탁 시 위탁 업체와의 계약을 통해 개인정보 보호조치를 취하고 있습니다.
  </p>
  <p>예시 위탁업무:</p>
  <ul>
    <li>위탁업무: 이메일/메일링 시스템 운영·관리 및 응답</li>
    <li>수탁업체: 이메일 플랫폼 운영 혹은 시기적 지정</li>
  </ul>

  <h2>6. 이용자의 권리와 그 행사 방법</h2>
  <p>이용자는 언제든지 회사에 대해 다음과 같은 권리를 행사할 수 있습니다.</p>
  <ul>
    <li>본인 개인정보 조회, 수정, 삭제 요청</li>
    <li>수집·이용·제공에 대한 동의 철회</li>
  </ul>

  <h2>7. 개인정보의 파기 절차 및 방법</h2>
  <p>회사는 개인정보 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 해당 정보를 파기합니다.</p>
  <ul>
    <li>전자적 파일 형태: 복구가 불가능한 방법으로 영구 삭제</li>
    <li>서면: 분쇄 또는 소각</li>
  </ul>

  <h2>8. 개인정보 보호를 위한 안전성 확보 조치</h2>
  <p>회사는 개인정보를 보호를 위해 다음과 같은 기술적·관리적 보호조치를 취하고 있습니다.</p>
  <ul>
    <li>개인정보에 대한 접근 제한</li>
    <li>보안 프로그램 설치 및 주기적 업데이트</li>
    <li>개인정보 처리 직원 최소화 및 정기 교육</li>
  </ul>

  <h2>9. 개인정보 보호 책임자</h2>
  <p>이용자는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의를 아래 개인정보 보호책임자에게 문의할 수 있습니다.</p>
  <ul>
    <li>개인정보 보호책임자: 노승인</li>
    <li>이메일: bbmaster@bbtech.co.kr / 전화: 031-8009-0777</li>
    <li>담당부서: 경영지원팀</li>
  </ul>

  <h2>10. 고지의 의무</h2>
  <p>
    본 개인정보처리방침은 시행일로부터 적용되며, 내용 추가, 삭제 및 수정이 있을 경우 개정 최소 7일 전부터 홈페이지를 통해 공지합니다.
  </p>
  <ul>
    <li>공고일자: 2025년 5월 14일</li>
    <li>시행일자: 2025년 6월 1일</li>
  </ul>
</div>
</body>
</html>
`;

export const termsText = `
<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
</head>
<body>
<div class="terms">
<style>
    .terms p { font-size: 17px; }
    .terms li { font-size: 15px; }
    .terms h2 { font-size: 19px; }             /* 필요시 !important 추가 */
    .terms h3 { font-size: 19px; } 
    .terms h3 + ul { margin-top: -10px; }
    .terms p + ul { margin-top: -10px; }
    .terms h2 + p { margin-top: -10px; }
    .terms p + h2 { margin-top: 24px; }

    @media (max-width: 1439px) {
    .terms p  { font-size: 14px; }
    .terms li { font-size: 14px; }  
    .terms h1 { font-size: 24px; }      
    .terms h2 { font-size: 14px; }
    .terms h3 { font-size: 14px; }
  }
  </style>
  
  <h1>이용약관</h1>

  <p><b>본 이용약관은 비비테크 주식회사(이하‘회사’)가 제공하는 웹사이트를 이용함에 있어 필요한 사항을 규정함을 목적으로 합니다.</b></p>

  <h2>제1조 (서비스의 제공)</h2>
  <p>회사는 본 웹사이트를 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴로 운영함을 원칙으로 합니다.</p>

  <h2>제2조 (저작권)</h2>
  <p>본 웹사이트에 게시되는 모든 내용에 대한 저작권은 회사에 있으며, 타인은 이를 무단 복제, 배포, 전송, 기타 저작권 침해행위를 할 수 없습니다.</p>

  <h2>제3조 (손해배상의 면책)</h2>
  <p>본 웹사이트의 이용장애나 본 웹사이트에서 취득한 정보로 인해 문제가 발생하여 직·간접적으로 손해를 입었다 하더라도 회사는 어떠한 법적 책임도 지지 않습니다.</p>

  <h2>제4조 (문의사항)</h2>
  <p>이용자가 작성한 문의사항은 필요에 따라 담당부서로 이관되어 처리될 수 있습니다.</p>

  <h2>제5조 (약관의 준칙)</h2>
  <p>본 웹사이트에 연결되어 있는 개별서비스에 대하여는 별도의 서비스 이용규칙이 적용될 수 있습니다.</p>

  <h2>제6조 (재판권 및 준거법)</h2>
  <p>
    ① 본 약관에서 명시되지 않은 사항은 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 대한민국의 관계법령과 상관습에 따릅니다.
    <br />
    ② 웹사이트의 이용에 관련되어 발생한 분쟁에 대해 소송이 제기될 경우 관할법원은 회사 본사 소재지 관할 법원으로 합니다.
    <br />
    본 약관은 2025년 06월 30일부터 적용됩니다.
  </p>
  </div>
</body>
</html>
`;
